export default (props) => (
  /**
   * Ícone escala da cores degradê preta.
   * Utilizada no dropdown "Escala de cores"
   * na edição de simbologia.
   */
  <svg
    width="176"
    height="22"
    viewBox="0 0 176 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.447266 3.83594C0.447266 2.17909 1.79041 0.835938 3.44727 0.835938H17.9643V22.2474H3.44727C1.79041 22.2474 0.447266 20.9043 0.447266 19.2474V3.83594Z"
      fill="black"
    />
    <path
      d="M175.618 19.25C175.618 20.9069 174.275 22.25 172.618 22.25L158.101 22.25L158.101 0.838487L172.618 0.838487C174.275 0.838488 175.618 2.18163 175.618 3.83849L175.618 19.25Z"
      fill="#E5E5E5"
    />
    <path
      d="M17.9648 0.835938H35.4819V22.2474H17.9648V0.835938Z"
      fill="#1A1A1A"
    />
    <path
      d="M35.4814 0.835938H52.9985V22.2474H35.4814V0.835938Z"
      fill="#333333"
    />
    <path
      d="M52.9985 0.835938H70.5156V22.2474H52.9985V0.835938Z"
      fill="#4D4D4D"
    />
    <path
      d="M70.5151 0.835938H88.0322V22.2474H70.5151V0.835938Z"
      fill="#666666"
    />
    <path
      d="M88.0327 0.835938H105.55V22.2474H88.0327V0.835938Z"
      fill="#808080"
    />
    <path
      d="M105.55 0.835938H123.067V22.2474H105.55V0.835938Z"
      fill="#999999"
    />
    <path
      d="M123.066 0.835938H140.583V22.2474H123.066V0.835938Z"
      fill="#B3B3B3"
    />
    <path
      d="M140.584 0.835938H158.101V22.2474H140.584V0.835938Z"
      fill="#CCCCCC"
    />
  </svg>
);
